var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.campaign
    ? _c("form", { staticClass: "form-horizontal" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "form-group col-md-6" },
            [_c("CampaignName", { attrs: { campaign: _vm.campaign } })],
            1
          ),
          _c(
            "div",
            { staticClass: "form-group col-md-3" },
            [
              _c("StatusDropdown", {
                attrs: { campaign: _vm.campaign },
                on: {
                  updated: function ($event) {
                    return _vm.$emit("updated")
                  },
                },
              }),
            ],
            1
          ),
        ]),
        _c("hr"),
        _c(
          "div",
          { staticClass: "row" },
          [
            _c("CampaignDuration", {
              attrs: { campaign: _vm.campaign },
              on: {
                updated: function ($event) {
                  return _vm.$emit("updated")
                },
              },
            }),
          ],
          1
        ),
        _c("hr"),
        _c(
          "div",
          { staticClass: "row" },
          [
            _c("BackgroundImage", {
              attrs: { campaign: _vm.campaign },
              on: {
                updated: function ($event) {
                  return _vm.$emit("updated")
                },
              },
            }),
          ],
          1
        ),
        _c("hr"),
        _c(
          "div",
          { staticClass: "row" },
          [_c("TargetAndReward", { attrs: { campaign: _vm.campaign } })],
          1
        ),
        _c("hr"),
        _c(
          "div",
          { staticClass: "row" },
          [
            _c("TargetPrize", {
              attrs: { campaign: _vm.campaign },
              on: {
                updated: function ($event) {
                  return _vm.$emit("updated")
                },
              },
            }),
          ],
          1
        ),
        _c("hr"),
        _c(
          "div",
          { staticClass: "row" },
          [_c("TargetSKU", { attrs: { campaign: _vm.campaign } })],
          1
        ),
        _c("hr"),
        _c(
          "div",
          { staticClass: "row" },
          [
            _c("TargetAndRewardValues", {
              attrs: { campaign: _vm.campaign },
              on: {
                updated: function ($event) {
                  return _vm.$emit("updated")
                },
              },
            }),
          ],
          1
        ),
        _c("hr"),
        _c(
          "div",
          { staticClass: "row" },
          [_c("ProgressAndTargetReset", { attrs: { campaign: _vm.campaign } })],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }